export const SCREEN_ORIENTATIONS = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
}

export function toggleFullScreen(event) {
  const doc = window.document;
  let docEl = event.currentTarget;

  // if (event instanceof HTMLElement) {
  //   docEl = event;
  // }

  const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.webkitCurrentFullScreenElement || docEl.msRequestFullscreen;
  const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  console.log(requestFullScreen);

  if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement && !docEl.webkitCurrentFullScreenElement) {
    requestFullScreen?.call(docEl);
  }
  else {
    cancelFullScreen?.call(doc);
  }
}

export function toggleFullscreen2(event) {

  let element = document.body;

  if (event instanceof HTMLElement) {
    element = event;
  }

  var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

  element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
  document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };

  isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
}